export const COMMON_TRANSLATION = 'common';
export const LOGIN_TRANSLATION = 'login';
export const TOUR_TRASH_TRANSLATION = 'tourTrash';
export const PRODUCT = 'product';
export const ACTIVITY_LOG = 'activityLog';
export const HOME = 'home';
export const PROMOTION = 'promotion';
export const BENEFIT = 'benefit';
export const PARTNER = 'partner';
export const ACCESS_CODE = 'accessCode';
export const TRY_THEN_BUY = 'tryThenBuy';
export const TRY_THEN_BUY_FRAUD = 'tryThenBuyFraud';
export const GRAPHICS = 'graphics';
export const MISC = 'misc';
export const LAUNCH_FEATURES = 'launchFeatures';
export const USER_PROFILE = 'userProfile';
export const PAID_FEATURES = 'paidFeatures';
export const LOYALTY_ACTION = 'loyaltyAction';
export const PRODUCT_TILE = 'productTile';
export const THE_DAILY = 'theDaily';
export const MORE_FOR_YOU = 'moreForYou';
export const MAINSTAYS = 'mainstays';
export const HOME_PRODUCT = 'homeProduct';
export const CARTNER_CONVOS = 'cartnerConvos';
export const PLAYER_COACH = 'playerCoach';
export const JUST_IN_CLUBHOUSE = 'justInClubhouse';
export const TOUR_STORIES = 'tourStories';
export const SHOP_CATEGORIES = 'shopCategories';
export const GAME_PROFILE = 'gameProfile';
